import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useMobileMenuReset } from "../../Utils/useMobileMenuReset";
function HeaderArea() {
  // Use the custom hook to automatically reset mobile menu on navigation
  useMobileMenuReset();
  // Ensure smooth open/close via Bootstrap Collapse and close on outside click
  useEffect(() => {
    const collapseEl = document.getElementById('lawgisNav');
    const toggler = document.querySelector('.header-area.style-two .navbar-toggler');
    const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;

    if (!collapseEl || !CollapseCtor) return;

    const collapse = CollapseCtor.getOrCreateInstance(collapseEl, { toggle: false });

    const handleOutsideClick = (event) => {
      const navbar = document.querySelector('.header-area.style-two .navbar');
      if (!navbar || !collapseEl.classList.contains('show')) return;
      if (!navbar.contains(event.target)) {
        collapse.hide();
      }
    };

    // Close on any nav link click inside this header
    const navLinks = document.querySelectorAll('.header-area.style-two .navbar-nav a, .header-area.style-two .navbar-nav .magnet-link');
    const handleNavLinkClick = () => collapse.hide();
    navLinks.forEach(link => link.addEventListener('click', handleNavLinkClick));

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
      navLinks.forEach(link => link.removeEventListener('click', handleNavLinkClick));
    };
  }, []);
  
  return (
    <div>
      <header className="header-area style-two style-three">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            {/* Navbar Brand */}
            <Link className="navbar-brand" to="/">
              <img src="assets/img/core-img/logo-light.png" alt="" />
            </Link>

            {/* Navbar Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              aria-controls="lawgisNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={(e) => {
                const collapseEl = document.getElementById('lawgisNav');
                const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;
                if (!collapseEl || !CollapseCtor) return;
                const collapse = CollapseCtor.getOrCreateInstance(collapseEl, { toggle: false });
                const isOpen = collapseEl.classList.contains('show');
                if (isOpen) {
                  collapse.hide();
                  e.currentTarget.setAttribute('aria-expanded', 'false');
                } else {
                  collapse.show();
                  e.currentTarget.setAttribute('aria-expanded', 'true');
                }
              }}
            >
              <i className="ti ti-category"></i>
            </button>

            {/* Navbar Nav */}
            <div
              className="collapse navbar-collapse justify-content-end"
              id="lawgisNav"
            >
              <ul className="navbar-nav navbar-nav-scroll">
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Home <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/">
                        Home One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/hometwo">
                        Home Two
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homethree">
                        Home Three
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homefour">
                        Home Four
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homefive">
                        Home Five
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Pages <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="/aboutus">
                        About Us
                      </Link>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Service <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/service">
                            Service
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/servicedetails">
                            Service Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Case Studies <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/casestudy">
                            Case Study
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/casestudydetails">
                            Case Study Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Team <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/team">
                            Team
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/teamdetails">
                            Team Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/pricing">
                        Pricing Plan
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/faq">
                        FAQ
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/pagenotfound">
                        404 - Error
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link className="magnet-link" to="/casestudy">
                    Case Studies
                  </Link>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Blog <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/blogone">
                        Blog One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/blogtwo">
                        Blog Two
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/blogdetails">
                        Blog Details
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Contact <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/contactone">
                        Contact One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/contacttwo">
                        Contact Two
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>

              <div className="d-flex align-items-center">
                {/* Search Button */}
                <div className="header-search-btn" id="searchButton">
                  <button className="btn text-dark">
                    <i className="ti ti-search"></i>
                  </button>
                </div>

                {/* Call Now */}
                <Link to="tel:+1234567890" className="call-now-btn">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.95 21C17.8667 21 15.8083 20.546 13.775 19.638C11.7417 18.73 9.89167 17.4423 8.225 15.775C6.55833 14.1077 5.271 12.2577 4.363 10.225C3.455 8.19233 3.00067 6.134 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07933 8.725 3.238C8.90833 3.39667 9.01667 3.584 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.704 12.1123 8.162 12.687C8.62 13.2617 9.12433 13.816 9.675 14.35C10.1917 14.8667 10.7333 15.346 11.3 15.788C11.8667 16.23 12.4667 16.634 13.1 17L15.45 14.65C15.6 14.5 15.796 14.3877 16.038 14.313C16.28 14.2383 16.5173 14.2173 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1377 20.775 15.313C20.925 15.4883 21 15.684 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z"
                        fill="#161D27"
                      />
                    </svg>
                  </div>
                  <div>
                    <span>Call Any Time</span>
                    <span>869-878-08-68</span>
                  </div>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default HeaderArea;
